import * as React from "react";
const SvgFiRrCatSpace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cat-space_svg__a)">
      <path
        fill="#062147"
        d="M2.5 3.452a.75.75 0 0 1 .484-.687l1.3-.492.52-1.301a.75.75 0 0 1 1.393 0L6.72 2.28l1.308.523a.75.75 0 0 1 0 1.394L6.72 4.72l-.523 1.308a.75.75 0 0 1-1.394 0l-.526-1.316-1.318-.556a.75.75 0 0 1-.459-.704M24 23a1 1 0 0 1-1 1H6.558c-.136 0-.77-.018-.869-.05C2.762 23.618 0 21.633 0 18.5c0-2.135.945-3.659 1.778-5.004C2.433 12.439 3 11.527 3 10.5 3 8.94 2.362 8.19.868 7.991A1 1 0 0 1 .01 6.868a.997.997 0 0 1 1.123-.859C3.626 6.341 5 7.936 5 10.5c0 1.597-.773 2.844-1.52 4.051C2.717 15.777 2 16.935 2 18.5c0 1.791 1.467 2.851 2.997 3.279-.004-1.12.234-7.646 6.022-11.145A6.96 6.96 0 0 1 10 7.001c0-3.859 3.141-7 7-7s7 3.141 7 7c0 1.903-.764 3.63-2 4.893v10.107h1c.553 0 1 .446 1 .999m-4-9.676A7 7 0 0 1 17 14a6.97 6.97 0 0 1-4.688-1.806C6.756 15.336 6.985 21.719 7 22H16c0-2.206-1.794-4-4-4a1 1 0 1 1 0-2c3.31 0 6 2.691 6 6h2zm1-9.757a.552.552 0 0 0-.982-.346l-1.046 1.3A4 4 0 0 0 17 4c-.717 0-1.39.19-1.972.521l-1.046-1.3a.552.552 0 0 0-.982.346v3.255c0 2.088 1.522 3.956 3.6 4.159a4.005 4.005 0 0 0 4.4-3.98z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cat-space_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCatSpace;
